(function(){
 
'use strict';
 
const SHEET_URL =
'https://docs.google.com/spreadsheets/d/e/2PACX-1vR_etSx1bCt1sXb21yWH_bU9LGD6M3s887Uvm2X5zDF-LB7pfEsYVi9GKIIDgBKIx4Z7rm6C355qgdp/pub?gid=1713560037&single=true&output=csv';
 
 
// ---------- County centre coordinates (static lookup, no geocoding) -------
//
// We don't use Nominatim at all. Every UK county (current, historic, and
// preserved) is in this table with a single pin placed at roughly the
// centre of the area. The team can override any county by adding a row
// to the theme-editor textarea in the format:
//
//     spreadsheet_name = lat, lon
//
// (for example: cumberland = 54.5, -3.1) - which lets them nudge a pin
// without touching code.
//
// "null" after the = means "skip this county entirely" (e.g. non-UK).
 
function parseCountyFixes(text){
  let out = {};
  if (!text) return out;
  text.split(/\r?\n/).forEach(function(line){
    line = line.trim();
    if (!line || line.charAt(0) === '#') return;
    let idx = line.indexOf('=');
    if (idx < 0) return;
    let key = line.slice(0, idx).trim().toLowerCase();
    let val = line.slice(idx + 1).trim();
    if (!key) return;
    if (val.toLowerCase() === 'null') { out[key] = null; return; }
    // Parse "lat, lon" pair
    let m = val.split(/[,\s]+/).filter(Boolean).map(Number);
    if (m.length === 2 && !isNaN(m[0]) && !isNaN(m[1])) {
      out[key] = m;
    } else {
      // unknown format - treat as skip
      out[key] = null;
    }
  });
  return out;
}
 
function loadCountyFixes(section){
  let raw = section.getAttribute('data-county-fixes') || '';
  // Shopify's | url_encode is CGI.escape (space -> '+'); reverse that first.
  raw = raw.replace(/\+/g, ' ');
  try { raw = decodeURIComponent(raw); } catch(e) {}
  return parseCountyFixes(raw);
}
 
const DEFAULT_FIXES = {
  // --- England: current ceremonial counties ---
  'bedfordshire': [52.0, -0.4],
  'berkshire': [51.4, -1.0],
  'bristol': [51.45, -2.59],
  'buckinghamshire': [51.8, -0.8],
  'cambridgeshire': [52.3, 0.1],
  'cheshire': [53.2, -2.5],
  'city of london': [51.51, -0.12],
  'cornwall': [50.4, -4.7],
  'cumbria': [54.5, -3.0],
  'derbyshire': [53.1, -1.6],
  'devon': [50.7, -3.7],
  'dorset': [50.8, -2.4],
  'durham': [54.7, -1.8],
  'east riding of yorkshire': [53.9, -0.5],
  'east sussex': [50.95, 0.25],
  'essex': [51.8, 0.6],
  'gloucestershire': [51.8, -2.2],
  'greater london': [51.51, -0.12],
  'greater manchester': [53.48, -2.24],
  'hampshire': [51.0, -1.3],
  'herefordshire': [52.1, -2.7],
  'hertfordshire': [51.8, -0.2],
  'isle of wight': [50.65, -1.3],
  'kent': [51.2, 0.7],
  'lancashire': [53.9, -2.6],
  'leicestershire': [52.65, -1.15],
  'lincolnshire': [53.2, -0.4],
  'merseyside': [53.4, -3.0],
  'norfolk': [52.6, 1.0],
  'north yorkshire': [54.2, -1.4],
  'northamptonshire': [52.3, -0.9],
  'northumberland': [55.3, -1.8],
  'nottinghamshire': [53.1, -1.1],
  'oxfordshire': [51.75, -1.4],
  'rutland': [52.65, -0.65],
  'shropshire': [52.6, -2.7],
  'somerset': [51.1, -3.1],
  'south yorkshire': [53.5, -1.4],
  'staffordshire': [52.8, -2.1],
  'suffolk': [52.2, 1.1],
  'surrey': [51.25, -0.4],
  'tyne and wear': [54.95, -1.6],
  'warwickshire': [52.3, -1.6],
  'west midlands': [52.5, -1.9],
  'west sussex': [50.95, -0.45],
  'west yorkshire': [53.7, -1.7],
  'wiltshire': [51.3, -1.9],
  'worcestershire': [52.2, -2.2],
 
  // --- England: historic (pre-1974) county names still seen in old data ---
  'cumberland': [54.5, -3.0],
  'westmorland': [54.4, -2.8],
  'huntingdonshire': [52.3, 0.1],
  'middlesex': [51.5, -0.1],
  'yorkshire': [54.0, -1.5],
  'north riding yorkshire': [54.3, -1.4],
  'west riding yorkshire': [53.8, -1.6],
  'east riding yorkshire': [53.85, -0.5],
  'county durham': [54.7, -1.8],
  'sussex': [50.95, 0.25],
  'linconshire': [53.2, -0.4],
 
  // --- Scotland: historic counties (centres of modern council areas) ---
  'aberdeenshire': [57.3, -2.5],
  'angus': [56.7, -2.9],
  'argyll': [56.2, -5.4],
  'argyllshire': [56.2, -5.4],
  'ayrshire': [55.5, -4.4],
  'banffshire': [57.5, -2.8],
  'berwickshire': [55.7, -2.5],
  'bute': [55.8, -5.0],
  'buteshire': [55.8, -5.0],
  'caithness': [58.4, -3.4],
  'clackmannanshire': [56.1, -3.7],
  'dumfriesshire': [55.1, -3.5],
  'dunbartonshire': [55.95, -4.55],
  'east lothian': [55.95, -2.75],
  'fife': [56.25, -3.05],
  'inverness-shire': [57.0, -4.5],
  'kincardineshire': [56.85, -2.5],
  'kinross': [56.2, -3.4],
  'kinross-shire': [56.2, -3.4],
  'kirkcudbrightshire': [54.9, -4.0],
  'lanarkshire': [55.6, -3.8],
  'midlothian': [55.85, -3.05],
  'moray': [57.4, -3.2],
  'morayshire': [57.4, -3.2],
  'nairnshire': [57.5, -3.8],
  'orkney': [59.0, -3.0],
  'peeblesshire': [55.6, -3.2],
  'perthshire': [56.5, -4.0],
  'renfrewshire': [55.8, -4.5],
  'ross and cromarty': [57.6, -4.8],
  'roxburghshire': [55.5, -2.5],
  'selkirkshire': [55.55, -2.85],
  'shetland': [60.3, -1.3],
  'stirlingshire': [56.1, -4.0],
  'sutherland': [58.2, -4.4],
  'west lothian': [55.9, -3.55],
  'wigtownshire': [54.8, -4.7],
  'zetland': [60.3, -1.3],
 
  // --- Wales: preserved counties (centres of modern principal areas) ---
  'anglesey': [53.3, -4.4],
  'brecknockshire': [51.95, -3.4],
  'breconshire': [51.95, -3.4],
  'caernarfonshire': [53.0, -4.0],
  'caernarvonshire': [53.0, -4.0],
  'cardiganshire': [52.3, -3.9],
  'carmarthenshire': [51.85, -4.2],
  'denbighshire': [53.05, -3.35],
  'flintshire': [53.2, -3.1],
  'glamorgan': [51.55, -3.4],
  'glamorganshire': [51.55, -3.4],
  'merionethshire': [52.75, -3.85],
  'monmouthshire': [51.75, -2.85],
  'montgomeryshire': [52.55, -3.5],
  'pembrokeshire': [51.85, -4.85],
  'radnorshire': [52.3, -3.4],
 
  // --- Northern Ireland ---
  'antrim': [54.7, -6.2],
  'county antrim': [54.7, -6.2],
  'armagh': [54.35, -6.65],
  'county armagh': [54.35, -6.65],
  'down': [54.35, -5.85],
  'county down': [54.35, -5.85],
  'fermanagh': [54.35, -7.65],
  'county fermanagh': [54.35, -7.65],
  'londonderry': [54.95, -6.95],
  'county londonderry': [54.95, -6.95],
  'derry': [54.95, -6.95],
  'tyrone': [54.6, -7.3],
  'county tyrone': [54.6, -7.3],
 
  // --- Crown dependencies ---
  'isle of man': [54.23, -4.55],
  'jersey': [49.21, -2.13],
  'guernsey': [49.46, -2.59],
 
  // --- Non-UK: skip ---
  'roi producer': null,
  'roi': null,
  'republic of ireland': null,
};
 
 
document.addEventListener('DOMContentLoaded',()=>{
 
const sections = document.querySelectorAll('.wool-farmers');
console.log('[WoolFarmers] boot() called,', sections.length, 'section(s)');
sections.forEach(init);
 
});
 
 
function init(section){
 
let farmers=[];
let map;
let layer;
let stats = { counties: 0, plotted: 0, skipped: 0 };
 
// Merge defaults with theme-editor overrides; overrides win
let COUNTY_CENTRES = Object.assign({}, DEFAULT_FIXES, loadCountyFixes(section));
console.log('[WoolFarmers] loaded', Object.keys(COUNTY_CENTRES).length, 'county centres (' + Object.keys(DEFAULT_FIXES).length + ' built-in, ' + (Object.keys(COUNTY_CENTRES).length - Object.keys(DEFAULT_FIXES).length) + ' from theme settings)');
 
const tbody=section.querySelector('.wool-farmers__rows');
const count=section.querySelector('.wool-farmers__count');
const search=section.querySelector('.wool-farmers__search');
const filter=section.querySelector('.wool-farmers__filter');
const mapBox=section.querySelector('.wool-farmers__map');
 
 
fetch(SHEET_URL)
.then(r=>r.text())
.then(csv=>{
 
farmers=deduplicate(parseCSV(csv));
console.log('[WoolFarmers] CSV parsed:', farmers.length, 'farmers (after dedup)');
 
render(farmers);
filters();
loadMap();
 
})
.catch(err => {
  console.error('[WoolFarmers] CSV fetch failed:', err);
  if(count) count.textContent = 'Could not load farmer data';
});
 
 
function deduplicate(rows){
  // The Sheet sometimes lists the same farmer more than once with an
  // identical (name, lot number, county) triple. We dedup on that triple
  // - not just on name, because two different people in the same county
  // can legitimately share a surname.
  return rows.filter(r=>
(r['farmer number']||'').trim()
);
}
 
 
function render(data){
 
tbody.innerHTML='';
 
 
data.forEach(f=>{
 
let row=document.createElement('tr');
 
row.innerHTML=`
<td>${f['lot number']||''}</td>
<td>${f['farmer name']||''}</td>
<td>${f['farmer number']||''}</td>
<td>${f['county']||''}</td>
<td>${f['flock size (2020)']||''}</td>
<td>${f['wool in lot']||''}</td>
<td>${f['product type']||''}</td>
<td>${f['processed']||''}</td>
`;
 
tbody.appendChild(row);
 
});
 
 
count.textContent=data.length+' farmers';
 
}
 
 
function filters(){
 
[...new Set(
farmers.map(f=>f['product type']).filter(Boolean)
)]
.forEach(x=>{
 
 
let option=document.createElement('option');
 
option.value=x;
option.textContent=x;
filter.appendChild(option);
 
 
});
 
 
function apply(){
 
let term=search.value.toLowerCase();
 
let type=filter.value;
 
 
let visible=farmers.filter(f=>{
 
if(type && f['product type']!==type)return false;
 
if(term && !(f['lot number']||'').toLowerCase().includes(term))return false;
 
return true;
 
});
 
 
render(visible);
drawMap(visible);
 
}
 
 
search.addEventListener('input',apply);
filter.addEventListener('change',apply);
 
}
 
 
function loadMap(){
 
if(!mapBox)return;
 
if(!window.L){
console.warn('[WoolFarmers] Leaflet not loaded');
return;
}
 
 
mapBox.innerHTML='';
 
 
map = L.map(mapBox, { minZoom: 5, maxZoom: 9 }).setView([54.5, -3], 6); 
 
setTimeout(()=>{ map.invalidateSize(); }, 100);
 
 
L.tileLayer(
'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
{ attribution: '&copy; OpenStreetMap contributors', maxZoom: 18 }
).addTo(map);
 
 
layer=L.layerGroup()
.addTo(map);
 
 
drawMap(farmers);
 
}
 
 
function drawMap(data){
 
if(!layer)return;
 
layer.clearLayers();
 
 
// Group farmers by county, preserving the first-seen capitalisation
// for display purposes
let counties = {};
 
data.forEach(f=>{
  let c = (f['county'] || '').trim();
  if (!c) return;
  counties[c] = counties[c] || [];
  counties[c].push(f);
});
 
stats.counties = Object.keys(counties).length;
console.log('[WoolFarmers] drawMap:', stats.counties, 'unique counties');
 
 
// Track how many farmers are already at a given (lat,lon) so we can
// offset overlapping pins slightly (a "stacked deck" effect) instead
// of hiding farmers behind a single pin.
let seenAt = {};
 
Object.entries(counties).forEach(([county, farmerList]) => {
 
  const lower = county.toLowerCase();
  const override = COUNTY_CENTRES[lower];
 
  // Skip-list (null entry)
  if (override === null) {
    stats.skipped += farmerList.length;
    console.log('[WoolFarmers] skip:', county, '(' + farmerList.length + ' farmers)');
    return;
  }
 
  // Unknown county - no centre, can't plot
  if (!override) {
    stats.skipped += farmerList.length;
    console.log('[WoolFarmers] no centre for:', county, '(' + farmerList.length + ' farmers)');
    return;
  }
 
  // Offset overlapping pins in a small spiral so all of them are
  // visible. This matters most for places with many farmers in the
  // same county (Cumberland has 76, North Riding Yorkshire has 60).
  let [lat, lon] = override;
  let key = lat.toFixed(2) + ',' + lon.toFixed(2);
  let offsetIndex = seenAt[key] = (seenAt[key] || 0) + 1;
  if (offsetIndex > 1) {
    // ~3km per step on a rough spiral
    const step = 0.03 * offsetIndex;
    const angle = offsetIndex * 1.7;
    lat += Math.cos(angle) * step;
    lon += Math.sin(angle) * step;
  }
 
  stats.plotted += farmerList.length;
 
  // Build a little sheep-icon marker. Using a divIcon with the 🐑
  // emoji at 28px so it reads at any zoom level.
  const icon = L.divIcon({
    className: 'wool-sheep-marker',
    html: '<span class="wool-sheep">🐑</span>',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
  });
 
  L.marker([lat, lon], { icon })
    .addTo(layer)
    .bindPopup(
      '<strong>' + escapeHtml(county) + '</strong><br>' +
      farmerList.length + (farmerList.length === 1 ? ' farmer' : ' farmers') +
      (farmerList.length <= 12
        ? '<hr>' + farmerList.map(f => escapeHtml(f['farmer name'] || '')).join('<br>')
        : '<hr><em>Click each table row to see the lot</em>')
    );
 
});
 
 
console.log('[WoolFarmers] plot summary:', stats);
 
}
 
 
function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}
 
 
}
 
 
function parseCSV(csv){
 
 
let rows=csv.split(/\r?\n/).filter(Boolean);
 
 
let headers=rows.shift()
.split(',')
.map(h=>h.replace(/^"|"$/g,'').trim().toLowerCase());
 
 
return rows.map(r=>{
 
 
let cells=[];
 
 
let inQ=false, cur='';
 
 
for(let i=0;i<r.length;i++){
 
 
let ch=r[i];
 
 
if(ch==='"'){
 
 
inQ=!inQ;
 
 
// Escaped quote inside quoted field
if(inQ && r[i+1]==='"'){cur+='"'; i++;}
 
 
continue;
 
}
 
 
if(ch===',' && !inQ){
 
 
cells.push(cur);
cur='';
 
continue;
 
}
 
 
cur+=ch;
 
}
 
 
cells.push(cur);
 
 
let obj={};
 
headers.forEach((h,i)=>{
 
 
obj[h]=(cells[i]||'').trim();
 
});
 
 
return obj;
 
 
}).filter(f=>f['farmer name']);
 
 
}
 
 
})();
